import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';

// custom components
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardFooter from "components/Card/CardFooter.jsx";
import Position from 'components/Position';
import DivCenter from "components/styled-components/DivCenter";

const renderCell = (column, rowData, openImageLightBox) => {
  const answer = rowData.answers.find(a => a.key === column.key);
  if (!answer) return '';

  const { __typename } = answer.answer;

  if (__typename === 'ImageSubFieldAnswer') {
    const img = answer.answer.ImageSubFieldAnswer[0] || '';
    if (!img) return '';

    return (
      <DivCenter>
        <img
          src={img.i320 || img.original}
          alt=""
          style={{ maxHeight: 60, cursor: 'pointer' }}
          onClick={() => openImageLightBox && openImageLightBox({
            images: [img.original],
            currentImage: 0,
          })}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = img.original;
          }}
        />
      </DivCenter>
    );
  }

  return <DivCenter>{answer.answer[__typename]}</DivCenter>;
};

const renderTable = (config, rows, openImageLightBox) => {
  return (
    <ReactTable
      data={rows}
      columns={config.columns.map((column, idx) => {
        return {
          id: idx,
          Header: <DivCenter>{column.label}</DivCenter>,
          filterable: false,
          sortable: false,
          Cell: (d) => renderCell(column, d.original, openImageLightBox),
          minWidth: column.width,
        }
      })}
      defaultPageSize={rows.length}
      showPaginationTop={false}
      showPaginationBottom={false}
      className="-striped -highlight"
      style={{
        height: "170px"
      }}
    />
  );
};

const TableFieldAnswerView = ({answerData, openImageLightBox}) => {
  const {config, rows} = answerData.answer;

  return (
    <Card >
      <CardBody>
        {!!rows && !!config ?
          renderTable(config, rows, openImageLightBox) :
          <DivCenter><h5>Informacion de configuracion o datos faltantes</h5></DivCenter>}
      </CardBody>
      <CardFooter>
        <Position left>
          <small>{answerData.questionLabel}</small>
        </Position>
        <Position right>
          <small>{answerData.key}</small>
        </Position>
      </CardFooter>
    </Card>
  );
};

TableFieldAnswerView.propTypes = {

};

export default TableFieldAnswerView;
